/*
 * =============================================================================
 * Project: payments.telestrada-online.pl
 * Created Date: 2018-07-11, 17:05:04
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-07-13, 11:26:03
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */
import { i18n } from '@/translate';
import { Notification } from 'element-ui';

export const errorHandlerInterceptor = (error) => {
  const errorMessage = i18n.tc(`http_errors.${error.response ? error.response.status : 500}`);
  Notification.error({
    title: 'Error',
    message: errorMessage,
  });

  Promise.reject(error);
};



// WEBPACK FOOTER //
// ./src/config/interceptors.js